<template>
  <div id="root">
    <div class="layer d-flex align-items-center">
      <d-container>
        <d-row class="justify-content-center">
          <d-col md="8">
            <d-card-group>
              <d-card id="left-card" class="p-4">
                <d-card-body>
                  <d-form>
                    <d-image src="img/logo-160x25.png" class="mb-2"></d-image>

                    <p class="text-danger" v-if="hasError">{{ errorMessage }}</p>

                    <c-input class="mt-4" label="Identifiant" placeholder="Ex: bob19" v-model="login"
                             :state="loginState">
                      Veuillez saisir votre login
                    </c-input>

                    <c-input class="mb-4" label="Mot de passe" type="password" placeholder="Votre mot de passe"
                             v-model="password" :state="passwordState">
                      Veuillez saisir votre mot de passe
                    </c-input>

                    <!--b-input-group class="mb-4 ml-1">
                      <b-form-checkbox v-model="remember" class="text-muted cursor-pointer"> Se souvenir de moi
                      </b-form-checkbox>
                    </b-input-group-->

                    <d-row>
                      <d-col cols="6">
                        <c-button-spinner variant="success" :fetching="fetchingLogin" @click="onLoginSubmit">
                          Valider
                        </c-button-spinner>
                      </d-col>
                    </d-row>
                  </d-form>
                </d-card-body>
              </d-card>
              <d-card id="right-card" class="text-white py-5">
                <d-card-body class="text-center">
                  <d-image src="img/logo-512x512.png" width="200" fluid thumbnail></d-image>
                </d-card-body>
              </d-card>
            </d-card-group>
            <d-container class="text-center text-white p-3">
              <d-form-checkbox v-model="production" inline toggle>
                {{env}}
              </d-form-checkbox>
            </d-container>
          </d-col>
        </d-row>
      </d-container>
    </div>
  </div>
</template>

<script>
import EnvMixin from "@/mixins/EnvMixin"
import {Api, Auth} from "@/helpers"

export default {
  name: 'Login',
  title: "Connexion",
  mixins: [EnvMixin],
  data() {
    return {
      submitted: false,
      fetchingLogin: false,
      login: "",
      password: "",
      remember: true
    }
  },
  computed: {
    loginState() {
      return !this.submitted || this.login.length >= 3
    },
    passwordState() {
      return !this.submitted || this.password.length > 0
    }
  },
  methods: {
    loginFormValid() {
      return this.login.length >= 3 && this.password.length > 0
    },
    authenticateUser(data) {
      Auth.authenticateUser(data, this.remember)
      const to = this.$route.query.redirect
      if (to)
        this.$router.push(to)
      else
        this.$router.push({name: 'index'})
    },
    onLoginSubmit() {
      this.submitted = true
      if (!this.loginFormValid())
        return

      this.fetchingLogin = true
      Api.post('/auth/login', {
        login: this.login,
        password: this.password
      })
        .then(res => {
          if (res.status === "success" && res.data)
            this.authenticateUser(res.data)
          else
            this.error = res
        })
        .catch(error => {
          this.error = error
        })
        .then(() => {
          this.fetchingLogin = false
        })
    }
  }
}
</script>

<style scoped>
#root {
  background: url("/img/dashboard.jpg") 50% fixed;
  background-size: cover;
  width: 100vw;
  height: 100vh;
}

.layer {
  background: rgba(0, 0, 0, .5);
  position: absolute;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
}

@media (max-width: 992px) {
  #left-card {
    border-radius: 0.625rem;
  }

  #left-card .card-body {
    border: none;
  }

  #right-card {
    display: none;
  }
}
</style>
